// extracted by mini-css-extract-plugin
export default {"title":"Confirmation_title__lj6wn","error_text":"Confirmation_error_text__WMZll","xcircle":"Confirmation_xcircle__LIcJZ","link":"Confirmation_link__GZF-V"};